// Auto-generated normalizer for table: Empleados
export function empleadosNormalize(row) {
  return {
    idEmpleado:       row.idEmpleado       ?? row.IdEmpleado       ?? row['IdEmpleado']       ?? 0,
    idPersona:        row.idPersona        ?? row.IdPersona        ?? row['IdPersona']         ?? 0,
    numeroEmpleado:   row.numeroEmpleado   ?? row.NumeroEmpleado   ?? row['numero_Empleado']   ?? row['Numero_Empleado'] ?? '',
    // Empresa efectiva resuelta por el SP (UO → Personas fallback)
    idEmpresaEfectiva: row.idEmpresaEfectiva ?? row.IdEmpresaEfectiva ?? row['IdEmpresaEfectiva'] ?? null,
    nombreEmpresa:     row.nombreEmpresa     ?? row.NombreEmpresa     ?? row['NombreEmpresa']     ?? null,
    empresaDelegada:   !!(row.empresaDelegada ?? row.EmpresaDelegada ?? row['EmpresaDelegada']),
    esAdminDelegado:   !!(row.esAdminDelegado ?? row.EsAdminDelegado ?? row['EsAdminDelegado']),
    nombreAdminDelegado: row.nombreAdminDelegado ?? row.NombreAdminDelegado ?? row['NombreAdminDelegado'] ?? null,
    nombre:            row.nombre            ?? row.Nombre            ?? row['Nombre']            ?? '',
    apellidoPaterno:   row.apellidoPaterno   ?? row.ApellidoPaterno   ?? row['ApellidoPaterno']   ?? '',
    apellidoMaterno:   row.apellidoMaterno   ?? row.ApellidoMaterno   ?? row['ApellidoMaterno']   ?? '',
  };
}
